import { compact, uniq } from 'lodash';

interface IDesignFonts {
  loadFonts: string[];
  variables: { [key: string]: string };
}

interface ITemplateDefaults {
  newDefaultDesign?: { iconSet?: string; headingFont?: string };
}

/**
 * The icon set and heading font a template starts a gallery with. The gallery loads only the
 * fonts in `loadFonts`, so the heading font replaces whatever the previous template added there.
 */
export const templateDefaultDesign = (
  template: ITemplateDefaults | undefined,
  design: IDesignFonts
): Partial<IDesignFonts & { iconSet: string }> => {
  const { iconSet, headingFont } = template?.newDefaultDesign || {};

  return {
    ...(iconSet && { iconSet }),
    ...(headingFont && {
      loadFonts: uniq(compact([design.variables.font, headingFont])),
      variables: { ...design.variables, headingFont }
    })
  };
};
